import { Component, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '@service';

@Component({
  encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'bmd-spinner',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./spinner.component.css'],
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) {}
}
